import { CandidatePipelineTable } from "@components/campaigns/CandidatePipelineTable";
import { OutreachWorkspace } from "@components/campaigns/outreach/OutreachWorkspace";
import { AssessmentStage } from "@components/campaigns/stages/AssessmentStage";
import { LonglistStage } from "@components/campaigns/stages/LonglistStage";
import { OfferStage } from "@components/campaigns/stages/OfferStage";
import { PlacementStage } from "@components/campaigns/stages/PlacementStage";
import { SelectionJourneyStage } from "@components/campaigns/stages/SelectionJourneyStage";
import { ShortlistStage } from "@components/campaigns/stages/ShortlistStage";
import { CandidatePipelineSnapshot } from "./CandidatePipelineSnapshot";
import { useCampaignDetail } from "./context";
import { DiscoveryTab } from "./DiscoveryTab";
import { PipelineFunnelHeader } from "./PipelineFunnelHeader";
import { PoolTab } from "./PoolTab";
import { SlotStageActions } from "./slotStageActions";

// RUN slot bodies — Epic 0 #2218 assembles the execution surface from the same
// components the stepper renders, organised by the candidate journey rather
// than a linear 10-stage stepper. The stepper stays as a safety net until
// #2219, so these compose existing components; nothing is rewritten.

export function DiscoveryRunSlot() {
  return <DiscoveryTab />;
}

export function PoolRunSlot() {
  // PoolTab reads the campaign from outlet context itself.
  return <PoolTab />;
}

export function OutreachRunSlot() {
  // The drafts workspace is the whole stage-5 surface (#3169): no stage
  // action bar — its buttons live in the workspace toolbar.
  return <OutreachWorkspace />;
}

export function InterviewsRunSlot() {
  const { campaign } = useCampaignDetail();
  return (
    <div className="space-y-4">
      <SlotStageActions campaign={campaign} stages={[8]} />
      <SelectionJourneyStage campaignId={campaign.id} />
    </div>
  );
}

export function OffersRunSlot() {
  const { campaign } = useCampaignDetail();
  // Offers being negotiated above, placed candidates below.
  return (
    <div className="space-y-6">
      <SlotStageActions campaign={campaign} stages={[9, 10]} />
      <OfferStage campaignId={campaign.id} />
      <PlacementStage campaignId={campaign.id} />
    </div>
  );
}

// --- Pipeline sub-slots ---

export function PipelineOverviewRunSlot() {
  const { campaign } = useCampaignDetail();
  return (
    <div className="space-y-4">
      <PipelineFunnelHeader campaign={campaign} />
      <CandidatePipelineSnapshot campaignId={campaign.id} />
      <CandidatePipelineTable campaignId={campaign.id} />
    </div>
  );
}

export function LonglistRunSlot() {
  const { campaign } = useCampaignDetail();
  return (
    <div className="space-y-4">
      <SlotStageActions campaign={campaign} stages={[4]} />
      <LonglistStage campaignId={campaign.id} />
    </div>
  );
}

export function ScoringRunSlot() {
  const { campaign } = useCampaignDetail();
  return (
    <div className="space-y-4">
      <SlotStageActions campaign={campaign} stages={[6]} />
      <AssessmentStage campaignId={campaign.id} />
    </div>
  );
}

export function ShortlistRunSlot() {
  const { campaign } = useCampaignDetail();
  return (
    <div className="space-y-4">
      <SlotStageActions campaign={campaign} stages={[7]} />
      <ShortlistStage campaignId={campaign.id} />
    </div>
  );
}
